import styled from "styled-components";

//MISC
import { COLORS, SIZE, BORDER_RADIUS, DEVICE_TYPE } from "constants/variables";

//ASETS
import cursorIcon from "assets/img/Cursor.png";

export const CardWrapper = styled.button<{ biggerCursor: boolean }>`
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: ${SIZE.max220};
  height: ${SIZE.max220};
  background-color: ${COLORS.Cultured};
  border-radius: ${BORDER_RADIUS.radius24};
  text-decoration: none;
  border: solid 1px ${COLORS.AbsoluteWhite};
  padding: ${SIZE.max40};
  gap: 6px;
  transition: background-color 0.3s ease-in-out;
  &:hover {
    background-color: rgba(245, 245, 245, 0.6);
    transition: 0.3s ease-in-out;
  }
`;

export const Antet = styled.div`
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: flex;
  justify-content: flex-start;
`;

export const TitleWrapper = styled.div`
  width: 100%;
  height: auto;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 4;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    -webkit-line-clamp: 3;
  }
`;
